import { styled } from 'styled-components';

export const FaqBrowsingSectionWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
`;

export const FaqBrowsingSectionContainer = styled.div<{
  $withBreadcrumbs?: boolean;
}>`
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  gap: 48px;
  padding: 0px 40px 96px 40px;
  padding-top: ${({ $withBreadcrumbs }) =>
    $withBreadcrumbs ? '120px' : '0px'};
  display: grid;
  grid-template-columns: 296px auto;
  width: 100%;

  ${({ theme }) => theme.breakpoints.md.query} {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    padding: 36px 24px 96px 24px;
    padding-top: ${({ $withBreadcrumbs }) =>
      $withBreadcrumbs ? '180px' : '36px'};
  }
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  & > p {
    color: ${({ theme }) => theme.colors.default[600]};
    text-transform: uppercase;
  }
`;

export const QuestionContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 48px;
`;

export const QuestionContent = styled.div`
  & a {
    color: ${({ theme }) => theme.colors.primary.default};
  }

  & img {
    margin-bottom: 12px;
    margin-top: 12px;
    border-radius: 16px;
  }
`;

export const MenuContainer = styled.div<{ $mobileVisible: boolean }>`
  ${({ theme }) => theme.breakpoints.md.query} {
    display: ${({ $mobileVisible }) => ($mobileVisible ? 'block' : 'none')};
  }
`;
